<template>
	<!-- Start 导航栏 -->
	<div>
		<div class="it-expart-header-area" id="sticky-header">
			<div class="container">
				<div class="row align-items-center">
					<div class="col-lg-3">
						<div class="header-logo">
							<!-- <a href=""><img src="static/picture/logo.png" alt=""></a> -->
							<a href=""><img src="@/assets/image/logo.png" alt=""></a>
						</div>
					</div>
					<div class="col-lg-9">
						<div class="it-expart-menu">
							<ul>
								<li v-for="(item, index) in navList" :key="index" @click.stop="navClick(item)">
									<a href="javascript:;">{{ item.title }}<i v-if="item.subList.length" class="fas fa-chevron-down"></i></a>
									<div v-if="item.subList.length" class="sub-menu">
										<ul>
											<li v-for="(sub, i) in item.subList" :key="i">
												<!-- 注意这里不再需要 .stop 修饰符 -->
												<router-link :to="{ path: item.router, hash: sub.hash }" tag="a" @click.native="subClick(item, sub, $event)">{{ sub.title }}</router-link>
											</li>
										</ul>
									</div>
								</li>
							</ul>
						</div>
						<div class="it-expart-search-button">
							<div class="it-expart-social-menu" style="visibility: hidden;">
								<ul>
									<li><a class="search-box-btn search-box-outer" href="#"><i class="bi bi-search"></i></a>
									</li>
									<li><a class="handbag" href="#"><i class="bi bi-cart-fill"></i></a></li>
								</ul>
							</div>
							<div class="it-expart-btn style-one">
								<a @click="constactClick" class="header-button" href="javascript:;">联系我们<span></span></a>
							</div>
						</div>
					</div>
				</div>
				<div class="side-menu-info">
					<div class="sidebar-menu">
						<a class="navSidebar-button" href="#"><i class="bi bi-justify-right"></i></a>
					</div>
				</div>
			</div>
		</div>
		<!-- it-expart Mobile Menu Area -->
		<div class="mobile-menu-area sticky-menu" id="navbar">
			<div class="mobile-menu">
				<div class="mobile-logo">
					<a href=""><img src="@/assets/image/logo.png" alt=""></a>
				</div>
				<div class="side-menu-info">
					<div class="sidebar-menu">
						<a class="navSidebar-button" href="#"><i class="bi bi-justify-right"></i></a>
					</div>
				</div>
			</div>
		</div>
		<!-- End 导航栏 -->
	</div>
</template>

<script>
	export default {
		data() {
			return {
				navList: [
					{
						page: 'index',
						title: '首页',
						router: '/',
						subList: []
					},
					{
						page: 'product',
						title: '产品中心',
						router: '/product',
						subList: [
							{
								page: 'product',
								title: '软件产品',
								hash: '#fire',
							},
							{
								page: 'product',
								title: '消防/安全用电',
								hash: '#electrical',
							},
							{
								page: 'product',
								title: '结构安全',
								hash: '#structure',
							},
							{
								page: 'product',
								title: '水利灌区',
								hash: '#water',
							}
						]
					},
					{
						page: 'solution',
						title: '解决方案',
						router: '/solution',
						subList: [
							{
								page: 'product',
								title: '智慧消防',
								hash: '#fire',
							},
							{
								page: 'product',
								title: '安全用电',
								hash: '#electrical',
							},
							{
								page: 'product',
								title: '结构安全',
								hash: '#structure',
							},
							{
								page: 'product',
								title: '水利灌区',
								hash: '#water',
							}
						]
					},
					{
						page: 'case',
						title: '经典案例',
						router: '/case',
						subList: []
					},
					{
						page: 'news',
						title: '新闻资讯',
						router: '/news',
						subList: []
					},
					{
						page: 'about',
						title: '关于泽火',
						router: '/about',
						subList: []
					}
				]
			}
		},
		methods: {
			navClick(item) {
				if (item.router == this.$route.path) return
				this.$router.push({path: item.router})
			},
			subClick(item, sub, event) {
				// 阻止事件冒泡
				event.stopPropagation();
				// 你的子菜单点击逻辑
				this.$router.push({ path: item.router, hash: sub.hash });
			},
			constactClick() {
				if ('/contactUs' == this.$route.path) return
				this.$router.push('/contactUs')
			}
		}
	}
</script>

<style lang="scss" scoped>
</style>